import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGavel, faSpinner } from '@fortawesome/free-solid-svg-icons';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = '* Required'
    }
    if (!values.launch) {
        errors.launch = '* Required (YYYY/MM/DD)';
    } else if (values.launch === "Unknown") {
        errors.launch = '* Required';
    }
    return errors;
};

const normalizeLaunchDate = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (!previousValue || value.length > previousValue.length) {

        if (onlyNums.slice(0, 4) > new Date().getUTCFullYear()) {
            return 2018 + '/' + onlyNums.slice(4)
        }

        if (onlyNums.slice(4, 6) > 12) {
            return onlyNums.slice(0, 4) + '/' + 12 + '/'
        }

        if (onlyNums.slice(6, 8) > new Date(onlyNums.slice(0, 4), onlyNums.slice(4, 6), 0).getUTCDate()) {
            return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4, 6) + '/' + new Date(onlyNums.slice(0, 4), onlyNums.slice(4, 6), 0).getUTCDate()
        }

        // typing forward
        if (onlyNums.length === 4) {
            return onlyNums + '/'
        }
        if (onlyNums.length === 6) {
            return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4) + '/'
        }
    }
    if (onlyNums.length <= 4) {
        return onlyNums
    }
    if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4)
    }
    return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4, 6) + '/' + onlyNums.slice(6, 8)
};

const ChaptersForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>

            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faGavel} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="title"
                        type="text"
                        label="Full Game Title"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span />}
                    />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="launch"
                        type="text"
                        label="Expected Launch Date"
                        fullWidth
                        onChange={this.handleChange}
                        helperText="(YYYY/MM/DD)"
                        normalize={normalizeLaunchDate}
                    />
                </div>
                <div className="adt-flex-item-small">
                    <Button type="submit" disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Open New Chapter
                    </Button>
                </div>
            </div>

        </Form>
    )
};

export default reduxForm({ form: 'chaptersForm', validate, })(ChaptersForm)


// WEBPACK FOOTER //
// ./src/Officer/ChaptersForm.js